export default {
  namespaced: true,
  state: {
    genreConfigs: [],
    prodCountry: [],
    primAudience: []
  },
  getters: {
    genreConfigs: state => state.genreConfigs,
    prodCountry: state => state.prodCountry,
    primAudience: state => state.primAudience
  },
  mutations: {
    setGenres(state, newValue) {
      state.genreConfigs = newValue;
    },
    setProdCountry(state, newValue) {
      state.prodCountry = newValue;
    },
    setPrimAudience(state, newValue) {
      state.primAudience = newValue;
    }
  }
};
